<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>スタッフ評価項目設定</template>
      <template v-slot:annotation>
        【{{ periodName }}】【{{ departmentName }}】<small>部署</small>【{{
          userName
        }}】
        <small v-if="!isEdit">
          さん の評価項目を表示します。※編集はできません。</small
        >
        <small v-if="isEdit">
          さん
          の評価項目の設定を行います。必要に応じて、目標内容などを変更してください。</small
        >
        <br />
        <div v-if="isEdit" style="text-align: left; padding: 10px 0px 0px 10px">
          <small class="pt-0 pb-0 pl-0 pr-3 ma-0">
            また、目標内容などを変更した後は、必ず、データチェックを実施してください。</small
          >
        </div>
      </template>
    </PageHeader>
    <v-row class="text-center px-3" v-if="isRateActive">
      <v-col cols="12" sm="3" md="3" lg="2" class="pt-0 pb-1 pl-3 pr-3 ma-0">
        <FormInputComponent
          label="人間力(%)"
          v-model="humanPowerRate"
          type="number"
          :counter="3"
          clearable
          v-bind:disabled="!isEdit"
        />
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="2" class="pt-0 pb-1 pl-3 pr-3 ma-0">
        <FormInputComponent
          label="チャレンジ目標(%)"
          v-model="challengeGoalRate"
          type="number"
          :counter="3"
          clearable
          v-bind:disabled="!isEdit"
        />
      </v-col>
      <v-col
        v-if="isEdit"
        cols="6"
        sm="2"
        md="2"
        lg="2"
        class="pt-0 pb-1 pl-3 pr-3 ma-0"
      >
        <Button @click="change_rate_confirm()" color="primary">比率更新</Button>
      </v-col>
      <v-col
        v-if="isEdit"
        cols="6"
        sm="2"
        md="2"
        lg="2"
        class="pt-0 pb-1 pl-3 pr-3 ma-0"
      >
        <Button color="info" @click="check_evaluation()">データチェック</Button>
      </v-col>
    </v-row>

    <v-row>
      <v-tabs v-model="tab" grow show-arrows>
        <v-tab v-if="isActionTabActive">{{ humanPowerTitle }}</v-tab>
        <v-tab v-if="isChallengeTabActive">{{ challengeGoalTitle }}</v-tab>
        <v-tab v-if="isTotalTabActive">{{ totalTargetTitle }}、他</v-tab>
      </v-tabs>
    </v-row>
    <p v-if="isActionTabActive">
      <StaffActionDetail
        v-if="tab === actionTabNo"
        :goalId="goalIdDbUse"
        :userId="userIdDbUse"
        :periodStatus="periodStatusDbUse"
      />
    </p>
    <p v-if="isChallengeTabActive">
      <StaffChallengeTarget
        v-if="tab === challengeTabNo"
        :goalId="goalIdDbUse"
        :userId="userIdDbUse"
        :periodStatus="periodStatusDbUse"
      />
    </p>
    <p v-if="isTotalTabActive">
      <StaffTotalTartget
        v-if="tab === totalTabNo"
        :goalId="goalIdDbUse"
        :userId="userIdDbUse"
        :periodStatus="periodStatusDbUse"
      />
    </p>
    <DialogMessage ref="dialog" />
    <ConfirmDialog
      ref="confirm"
      title="スタッフ評価項目編集"
      :message="confirmMessage"
      buttonMessage="OK"
      @confirm="editGoalInfo"
    >
    </ConfirmDialog>
    <DialogMessageAsync ref="asyncdialog" @confirm="asyncDialogBack">
    </DialogMessageAsync>
  </v-container>
</template>

<script>
import { getSessionStorageItem } from '../../common.js';
import StaffActionDetail from '@/components/pages/Manages/StaffActionDetail.vue';
import StaffChallengeTarget from '@/components/pages/Manages/StaffChallengeTarget.vue';
import StaffTotalTartget from '@/components/pages/Manages/StaffTotalTartget.vue';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import DialogMessageAsync from '@/components/Common/DialogMessageAsync.vue';
import axios from 'axios';
import config from '../../const.js';
import message from '../../message.js';
import moment from 'moment';

export default {
  components: {
    StaffActionDetail,
    StaffChallengeTarget,
    StaffTotalTartget,
    ConfirmDialog,
    DialogMessageAsync,
  },
  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: 'スタッフ評価設定',
          route: 'StaffEvaluationSetting',
        },
        {
          name: 'スタッフ評価項目設定',
          route: 'StaffEvaluationPartSetting',
        },
      ],
      userInfo: {},
      // TAB情報
      tab: 0,
      actionTabNo: 0,
      challengeTabNo: 1,
      totalTabNo: 2,
      isActionTabActive: false,
      isChallengeTabActive: false,
      isTotalTabActive: false,
      isEdit: false,
      isRateActive: true,
      hasAction: false,
      goalIdDbUse: '',
      userIdDbUse: '',
      periodStatusDbUse: '',
      userName: '',
      periodName: '',
      departmentName: '',
      confirmMessage: null,

      humanPowerTitle: '',
      challengeGoalTitle: '',
      totalTargetTitle: '',
      commentTitle: '',
      lastConfirmTitle: '',

      humanPowerRate: 0,
      challengeGoalRate: 0,
    };
  },

  props: {
    goalId: {
      type: [String, String],
      required: true,
    },
    userId: {
      type: [String, String],
      required: true,
    },
    periodStatus: {
      type: [String, String],
      required: true,
    },
  },

  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;

    this.goalIdDbUse = Buffer.from(this.goalId, 'base64').toString();
    this.userIdDbUse = Buffer.from(this.userId, 'base64').toString();
    this.periodStatusDbUse = Buffer.from(
      this.periodStatus,
      'base64'
    ).toString();

    // ログインユーザーチェック
    this.checkLoginUser();

    // 評価情報取得
    this.get_evaluation();
  },
  methods: {
    asyncDialogBack() {
      // ログイン画面遷移処理
      this.$router.push({ name: 'Login' });
    },
    async checkLoginUser() {
      // ローディング画像表示
      this.loading = true;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/login/user/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID
        )
        .then((response) => {
          // 評価データ取得
          if (response.status == 200) {
            if (response.data[0].USER_RANK != this.userInfo.USER_RANK) {
              var msgStr =
                'Hitonobiを操作しているスタッフ様の等級が変更されています。\n' +
                ' 操作で不具合が発生する可能性があるため、Hitonobiをログアウトします。';
              this.$refs.asyncdialog.open('info', msgStr);
              return;
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async change_rate_confirm() {
      // 人間力
      if (!this.humanPowerRate) {
        this.$refs.dialog.open(
          'info',
          '人間力比率が入力されていません。人間力比率を入力して下さい。'
        );
        return;
      }
      // 人間力 + チャレンジ目標
      var totalWeight =
        Number(this.humanPowerRate) + Number(this.challengeGoalRate);
      if (totalWeight != 100) {
        this.$refs.dialog.open(
          'info',
          '人間力比率とチャレンジ目標比率の合計が「100」でありません。\n' +
            ' 合計が「100」となるように比率を入力して下さい。'
        );
        return;
      }
      // チャレンジ
      if (!this.challengeGoalRate) {
        this.$refs.dialog.open(
          'info',
          'チャレンジ目標比率が入力されていません。チャレンジ目標比率を入力して下さい。'
        );
        return;
      } else {
        var goalRate = Number(this.challengeGoalRate);
        if (goalRate == 0) {
          this.$refs.dialog.open(
            'info',
            'チャレンジ目標比率には「0」を設定できません。\n' +
              ' チャレンジ目標比率の見直しをお願いします。'
          );
          return;
        }
      }

      // ローディング画像表示
      this.loading = true;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/evaluation/primary/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.goalIdDbUse +
            '/' +
            this.userIdDbUse
        )
        .then((response) => {
          // 評価データ取得
          if (response.status == 200) {
            if (response.data[0].GOAL_EDIT_FLG != config.EDIT_OK) {
              // 目標編集フラグが[0:編集許可 ]で、且つ、評価確定以外の場合に編集許可
              this.$refs.dialog.open(
                'info',
                '初回の自己評価が完了しているため、比率の更新はできません。\n' +
                  ' 自己評価者、一次評価者とご相談をお願いします。'
              );
              return;
            } else {
              // 確認ダイアログ表示
              this.confirmMessage = '比率情報を更新しますか？';
              this.$refs.confirm.open();
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 404) {
            errStr = message.MSG_INFO_ORGANIZATION_NOT_FOUND;
            this.$refs.dialog.open('info', errStr);
          } else if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editGoalInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      // 比率変更処理
      this.changeRateInfoRequest();
    },
    changeRateInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      // タブを一時的に非表示
      this.isActionTabActive = false;
      this.isChallengeTabActive = false;
      this.isTotalTabActive = false;

      //----- 目標比率更新リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/evaluation/rate/update',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            GOAL_ID: this.goalIdDbUse,
            USER_ID: this.userIdDbUse,
            HUMAN_POWER_RATE: this.humanPowerRate,
            CHALLENGE_GOAL_RATE: this.challengeGoalRate,
            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            this.humanPowerRate = Number(response.data[0].HUMAN_POWER_RATE);
            this.challengeGoalRate = Number(
              response.data[0].CHALLENGE_GOAL_RATE
            );

            if (this.humanPowerRate == 0) {
              this.hasAction = false;
            } else {
              this.hasAction = true;
            }

            // 評価項目タブを表示
            if (this.hasAction) {
              // 行動内容を表示する場合
              this.isActionTabActive = true;
              this.isChallengeTabActive = true;
              this.isTotalTabActive = true;
              this.actionTabNo = 0;
              this.challengeTabNo = 1;
              this.totalTabNo = 2;
            } else {
              // 行動内容を表示しない場合
              this.isActionTabActive = false;
              this.isChallengeTabActive = true;
              this.isTotalTabActive = true;
              this.actionTabNo = 9;
              this.challengeTabNo = 0;
              this.totalTabNo = 1;
            }
            this.tab = 0;

            msgStr = '比率情報の更新が成功しました。';
            this.$refs.dialog.open('info', msgStr);
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    async get_evaluation() {
      this.loading = true;

      if (this.userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      // タブを一時的に非表示
      this.isActionTabActive = false;
      this.isChallengeTabActive = false;
      this.isTotalTabActive = false;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/evaluation/primary/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.goalIdDbUse +
            '/' +
            this.userIdDbUse
        )
        .then((response) => {
          // 評価データ取得
          if (response.status == 200) {
            const items = response.data[0];
            this.userName = items.USER_NAME;
            this.periodName = items.PERIOD_NAME;
            this.departmentName = items.DEPARTMENT_NAME;

            // タイトル取得
            this.humanPowerTitle = response.data[0].HUMAN_POWER_TITLE;
            this.challengeGoalTitle = response.data[0].CHALLENGE_GOAL_TITLE;
            this.totalTargetTitle = response.data[0].TOTAL_TARGET_TITLE;
            this.commentTitle = response.data[0].COMMENT_TITLE;
            this.lastConfirmTitle = response.data[0].LAST_CONFIRM_TITLE;

            this.humanPowerRate = Number(response.data[0].HUMAN_POWER_RATE);
            if (this.humanPowerRate == 0) {
              this.hasAction = false;
            } else {
              this.hasAction = true;
            }
            this.challengeGoalRate = Number(
              response.data[0].CHALLENGE_GOAL_RATE
            );

            // 活性制御
            this.isEdit = false; // 初期状態:編集不可
            if (
              response.data[0].GOAL_EDIT_FLG == config.EDIT_OK &&
              this.periodStatusDbUse != config.PERIOD_STATUS_EVAL_COMPLETE
            ) {
              // 目標編集フラグが[0:編集許可 ]で、且つ、評価確定以外の場合に編集許可
              this.isEdit = true;
            }

            // 評価項目タブを表示
            if (this.hasAction) {
              // 行動内容を表示する場合
              this.isActionTabActive = true;
              this.isChallengeTabActive = true;
              this.isTotalTabActive = true;
              this.actionTabNo = 0;
              this.challengeTabNo = 1;
              this.totalTabNo = 2;
            } else {
              // 行動内容を表示しない場合
              this.isActionTabActive = false;
              this.isChallengeTabActive = true;
              this.isTotalTabActive = true;
              this.actionTabNo = 9;
              this.challengeTabNo = 0;
              this.totalTabNo = 1;
            }
            this.tab = 0;
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 404) {
            errStr = message.MSG_INFO_ORGANIZATION_NOT_FOUND;
            this.$refs.dialog.open('info', errStr);
          } else if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async check_evaluation() {
      this.loading = true;

      if (this.userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/evaluation/primary/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.goalIdDbUse +
            '/' +
            this.userIdDbUse
        )
        .then((response) => {
          //---- 行動内容チェック
          // タイトル
          let humanPowerTitle = response.data[0].HUMAN_POWER_TITLE;
          if (!humanPowerTitle) {
            this.$refs.dialog.open(
              'info',
              '行動内容のタイトルが未入力です。\n' +
                ' タイトルを入力してください。'
            );
            return;
          }
          // ウェイト
          let humanPowerRate = Number(response.data[0].HUMAN_POWER_RATE);
          if (humanPowerRate > 0) {
            let actEmt1Weight1 = Number(response.data[0].ACT_EMT_1_WEIGHT1);
            let actEmt1Weight2 = Number(response.data[0].ACT_EMT_1_WEIGHT2);
            let actEmt2Weight1 = Number(response.data[0].ACT_EMT_2_WEIGHT1);
            let actEmt2Weight2 = Number(response.data[0].ACT_EMT_2_WEIGHT2);
            let actEmt3Weight1 = Number(response.data[0].ACT_EMT_3_WEIGHT1);
            let actEmt3Weight2 = Number(response.data[0].ACT_EMT_3_WEIGHT2);
            let actEmt4Weight1 = Number(response.data[0].ACT_EMT_4_WEIGHT1);
            let actEmt4Weight2 = Number(response.data[0].ACT_EMT_4_WEIGHT2);
            let actEmt5Weight1 = Number(response.data[0].ACT_EMT_5_WEIGHT1);
            let actEmt5Weight2 = Number(response.data[0].ACT_EMT_5_WEIGHT2);
            let actEmt6Weight1 = Number(response.data[0].ACT_EMT_6_WEIGHT1);
            let actEmt6Weight2 = Number(response.data[0].ACT_EMT_6_WEIGHT2);

            let humanPowerTotal =
              actEmt1Weight1 +
              actEmt1Weight2 +
              actEmt2Weight1 +
              actEmt2Weight2 +
              actEmt3Weight1 +
              actEmt3Weight2 +
              actEmt4Weight1 +
              actEmt4Weight2 +
              actEmt5Weight1 +
              actEmt5Weight2 +
              actEmt6Weight1 +
              actEmt6Weight2;

            if (humanPowerRate != humanPowerTotal) {
              this.$refs.dialog.open(
                'info',
                '行動内容ウェイトの合計が' +
                  humanPowerRate +
                  'でありません。\n' +
                  ' 各行動内容のウェイトの合計が' +
                  humanPowerRate +
                  'となるように調整してください。'
              );
              return;
            }
          }

          //----- チャレンジ目標チェック
          // タイトル
          let challengeGoalTitle = response.data[0].CHALLENGE_GOAL_TITLE;
          if (!challengeGoalTitle) {
            this.$refs.dialog.open(
              'info',
              'チャレンジ目標のタイトルが未入力です。\n' +
                ' タイトルを入力してください。'
            );
            return;
          }
          // 凡例
          let challengeGoalGuide = response.data[0].CHALLENGE_GOAL_GUIDE;
          if (!challengeGoalGuide) {
            this.$refs.dialog.open(
              'info',
              'チャレンジ目標の凡例が未入力です。\n' +
                ' 凡例を入力してください。'
            );
            return;
          }
          // チャレンジ目標必須チェック
          /*
          if (response.data[0].CHG_GOAL_1_CONTENT == config.GOAL_EMPTY_STRING) {
            this.$refs.dialog.open(
              'info',
              this.challengeGoalTitle +
                'の入力が不足しています。\n' +
                ' ' +
                this.challengeGoalTitle +
                'は4つ固定入力のため、追加してください。'
            );
            return;
          }
          if (response.data[0].CHG_GOAL_2_CONTENT == config.GOAL_EMPTY_STRING) {
            this.$refs.dialog.open(
              'info',
              this.challengeGoalTitle +
                'の入力が不足しています。\n' +
                ' ' +
                this.challengeGoalTitle +
                'は4つ固定入力のため、追加してください。'
            );
            return;
          }
          if (response.data[0].CHG_GOAL_3_CONTENT == config.GOAL_EMPTY_STRING) {
            this.$refs.dialog.open(
              'info',
              this.challengeGoalTitle +
                'の入力が不足しています。\n' +
                ' ' +
                this.challengeGoalTitle +
                'は4つ固定入力のため、追加してください。'
            );
            return;
          }
          if (response.data[0].CHG_GOAL_4_CONTENT == config.GOAL_EMPTY_STRING) {
            this.$refs.dialog.open(
              'info',
              this.challengeGoalTitle +
                'の入力が不足しています。\n' +
                ' ' +
                this.challengeGoalTitle +
                'は4つ固定入力のため、追加してください。'
            );
            return;
          }
          */
          if (response.data[0].CHG_GOAL_1_CONTENT == config.GOAL_EMPTY_STRING) {
            this.$refs.dialog.open(
              'info',
              this.challengeGoalTitle +
                'の入力が不足しています。\n' +
                ' ' +
                this.challengeGoalTitle +
                'は最大4つ、最小で1つを追加してください。'
            );
            return;
          }
          // ウェイト
          let challengeGoalRate = Number(response.data[0].CHALLENGE_GOAL_RATE);
          let chgGoal1Weight = Number(response.data[0].CHG_GOAL_1_WEIGHT);
          let chgGoal2Weight = Number(response.data[0].CHG_GOAL_2_WEIGHT);
          let chgGoal3Weight = Number(response.data[0].CHG_GOAL_3_WEIGHT);
          let chgGoal4Weight = Number(response.data[0].CHG_GOAL_4_WEIGHT);

          let challengeGoalTotal =
            chgGoal1Weight + chgGoal2Weight + chgGoal3Weight + chgGoal4Weight;
          if (challengeGoalRate != challengeGoalTotal) {
            this.$refs.dialog.open(
              'info',
              'チャレンジ目標ウェイトの合計が' +
                challengeGoalRate +
                'でありません。\n' +
                ' 各チャレンジ目標のウェイトの合計が' +
                challengeGoalRate +
                'となるように調整してください。'
            );
            return;
          }

          //----- 総合目標、他チェック
          // 総合目標タイトル
          let totalGoalTitle1 = response.data[0].TOTAL_GOAL_TITLE_1;
          let totalGoalTitle2 = response.data[0].TOTAL_GOAL_TITLE_2;
          let totalGoalTitle3 = response.data[0].TOTAL_GOAL_TITLE_3;
          if (!totalGoalTitle1 || !totalGoalTitle2 || !totalGoalTitle3) {
            this.$refs.dialog.open(
              'info',
              '総合目標タイトル1～3のいずれかが未入力です。\n' +
                ' 総合目標タイトルを入力してください。'
            );
            return;
          }
          // 課題自己タイトル
          let taskSelfTitle1 = response.data[0].TASK_SELF_TITLE_1;
          let taskSelfTitle2 = response.data[0].TASK_SELF_TITLE_2;
          let taskSelfTitle3 = response.data[0].TASK_SELF_TITLE_3;
          if (!taskSelfTitle1 || !taskSelfTitle2 || !taskSelfTitle3) {
            this.$refs.dialog.open(
              'info',
              '課題自己タイトル1～3のいずれかが未入力です。\n' +
                ' 課題自己タイトルを入力してください。'
            );
            return;
          }
          // 課題管理タイトル
          let taskManageTitle1 = response.data[0].TASK_MANAGE_TITLE_1;
          let taskManageTitle2 = response.data[0].TASK_MANAGE_TITLE_2;
          let taskManageTitle3 = response.data[0].TASK_MANAGE_TITLE_3;
          if (!taskManageTitle1 || !taskManageTitle2 || !taskManageTitle3) {
            this.$refs.dialog.open(
              'info',
              '課題管理タイトル1～3のいずれかが未入力です。\n' +
                ' 課題管理タイトルを入力してください。'
            );
            return;
          }

          this.$refs.dialog.open(
            'info',
            'スタッフ評価データは正常に作成されています。\n' +
              ' 人事考課を開始できます。'
          );
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 404) {
            errStr = message.MSG_INFO_ORGANIZATION_NOT_FOUND;
            this.$refs.dialog.open('info', errStr);
          } else if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
